// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__20F11","aboutLeft":"About_aboutLeft__uPxgL","aboutRight":"About_aboutRight__1i_8e"};